import { useQuery } from '@tanstack/react-query';
import { getInvoiceTaxAuthorityConfig } from 'Services/invoices';
import { trackError } from 'Utils/errorMonitoring';

export default function (options = {}) {
    const {
        data: taxAuthorityConfigs,
        isLoading,
        isError,
    } = useQuery({
        queryKey: ['invoices', 'tax-authority-configs'],
        queryFn: getInvoiceTaxAuthorityConfig,
        onError: (error) => trackError(error),
        ...options,
    });

    return { taxAuthorityConfigs, isLoading, isError };
}
